import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useAudio } from '../context/AudioManagementContext';

const Dropdown = ({ options, selectedValue, onChange }) => {
  const { playClick, playHover } = useAudio();
  const [isOpen, setIsOpen] = useState(false);
  const [wait, setWait] = useState(false);
  const clickTimeout = useRef(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const debounceClick = (event) => {
    if (event) {
      if (event.stopPropagation) event.stopPropagation();
      if (event.cancelable && !event.isDefaultPrevented())
        event.preventDefault();
    }
    if (wait) return;
    setWait(true);

    playClick(0.5, () => setIsOpen(!isOpen));

    if (clickTimeout.current) {
      clearTimeout(clickTimeout.current);
    }

    clickTimeout.current = setTimeout(() => {
      setWait(false);
    }, 300);
  };

  const handleSelect = (value) => {
    playClick(0.5, () => {
      onChange(value);
      setIsOpen(false);
    });
  };

  const onHover = () => {
    playHover(0.2);
  };

  return (
    <div className={`custom-select ${isOpen && 'open'}`} ref={dropdownRef}>
      <div
        className="select-box pixel-corners"
        onMouseEnter={onHover}
        onClick={debounceClick}
        onTouchStart={debounceClick}
      >
        <span>{selectedValue || 'Select an option'}</span>
        <span className="arrow">v</span>
      </div>

      {isOpen && (
        <div className="options-list-wrapper pixel-corners-wrapper">
          <div className="options-list">
            {options.map((option) => (
              <div
                key={option.label}
                className="option"
                onClick={(event) => {
                  if (event) {
                    if (event.stopPropagation) event.stopPropagation();
                    if (event.cancelable && !event.isDefaultPrevented())
                      event.preventDefault();
                  }
                  handleSelect(option);
                }}
                onTouchStart={(event) => {
                  if (event) {
                    if (event.stopPropagation) event.stopPropagation();
                    if (event.cancelable && !event.isDefaultPrevented())
                      event.preventDefault();
                  }
                  handleSelect(option);
                }}
                onMouseEnter={onHover}
              >
                {option.label}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

Dropdown.propTypes = {
  options: PropTypes.array.isRequired,
  selectedValue: PropTypes.string,
  onChange: PropTypes.func
};

export default Dropdown;
